module.exports = __webpack_public_path__ + "img/8pic.1f7ec5e9.jpg";